import { HyperwalletCalculator } from './calculator/hyperwallet.calculator';
import type { CalculatorProps } from './calculator/lib/interfaces';

export class ShowTotalCalculatorFactory {
  static createCalculation({ show, stripe }: CalculatorProps): HyperwalletCalculator {
    return new HyperwalletCalculator({ stripe, show: { ...show, taxRate: stripe.currentSKU?.taxRate } });
  }
}
